import { ServerServices } from '../uiModels/openApiServices'
import type { ServerServicesType } from './useService'

export const isConfigurationServerService = (service: ServerServicesType) =>
  service === ServerServices.configuration
